// extracted by mini-css-extract-plugin
export default {"confirmation-modal":"ConfirmationModal_confirmation-modal__+w7H4"};